module.exports = __webpack_public_path__ + "img/lb.lb4e42399.svg";